import React,{useState,useEffect} from "react";
import ApiService from '../Components/apiService';
import { BASE_URL } from '../Components/Constant';
import { Table, Button, Typography, Checkbox,Row,Col,Tooltip,Popconfirm ,Spin, message} from 'antd';
import { CopyOutlined, DeleteOutlined,EditOutlined } from '@ant-design/icons';
import CompactLayoutEditor from "./CompactLayoutEditor";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
const { Title } = Typography;
  
const CompactLayout=({object})=>{

    console.log('object', object);

    const [allcompactLayout,setAllCompactLayout]=useState([]);
    const [fields,setFields]=useState({});
    const [selectedCompactLayout, setSelectedCompactLayout] = useState(null);
    const [showCompactLayoutEditor, setShowCompactLayoutEditor] = useState(false);
    const [recordPathField, setRecordPathField] = useState(null); // State to manage recordPathField
    const [loading,setLoading]=useState(true);
    const navigate = useNavigate();
    const security = useSelector((state) => state.data.items[0]);
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        if (!security?.system_settings?.compact_layout?.view) {
            message.error('You do not have permission to view compact layouts');
            return;
        }
        fetchCompactLayout();
        getFields();
    }, [object]);

    const fetchCompactLayout=async()=>{

        try {
            setLoading(true);
            const apiService = new ApiService(`${BASE_URL}/get_compact_layout/${object?.name}`, {}, 'GET');
            const responseData = await apiService.makeCall(navigate);
              if (responseData?.record_path_field) {
                setRecordPathField(responseData?.record_path_field); // Assuming you have a state to manage recordPathField
              }
              console.log('responseData', responseData);
            setAllCompactLayout(responseData);
        } catch (error) {
            console.error('Error fetching layouts or fields:', error);
        }
        finally{
            setLoading(false);
        }

    }


    const getFields=async()=>{

        try{
            const fieldApiService = new ApiService(`${BASE_URL}/mt_fields/object/${object?.name}`, {}, 'GET');
            const fieldResponse = await fieldApiService.makeCall(navigate);
            const filteredFields =fieldResponse.filter(
                field => !['recordCount'].includes(field.name)
              );

            setFields(filteredFields);


        }catch(error){

        }

    }

    const handleEditCompactLayout=(layout)=>{
        if(!security?.system_settings?.compact_layout?.edit){
            message.error('You do not have permission to edit compact layout');
            return;
        }
        setSelectedCompactLayout(layout); // Set the selected layout
        setShowCompactLayoutEditor(true); // Show the editor
        if (layout.record_path_field) {
            setRecordPathField(layout.record_path_field); // Update recordPathField state based on the selected layout
          }
    }


    const columns = [
        {
            title: "Object Name",
            dataIndex: "object_name",
            key: "object_name",
            sorter: (a, b) => a.object_name.localeCompare(b?.object_name),
            render: (text, record) => (
                <a onClick={() => handleEditCompactLayout(record)}>{text}</a>
            )
        },
        {
            title: "Title Field",
            dataIndex: "title_field",
            key: "title_field",
            sorter: (a, b) => a.title_field.localeCompare(b?.title_field),
        },
        {
            title: "Description",
            dataIndex: "description",
            key: "description",
        },
       
        {
            title: "Layout Fields",
            dataIndex: "layout_fields",
            key: "layout_fields",
            render: (_, record) => (
                <>
                    {record.layout_fields &&
                        record.layout_fields.map((field, index) => (
                            <div key={index}>
                                <strong>{field.display_label}</strong>: {field.field_name} (Order: {field.order})
                            </div>
                        ))}
                </>
            ),
        },


    ];

    columns.push({
        title: 'Action',
        key: 'operation',
        render: (_, layout) => (
          <>
          <Tooltip title="Edit">
            <EditOutlined
                onClick={() => handleEditCompactLayout(layout)}
                style={{ marginRight: 5, fontSize: '12px', cursor: 'pointer' }}
            />
            </Tooltip>
            <Tooltip title="Delete">
              <Popconfirm
                title="Are you sure you want to delete this item?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => {
                    if(!security?.system_settings?.compact_layout?.delete){
                        message.error('You do not have permission to delete compact layout');
                        return;
                    }
                }
                }
    
              >
                <DeleteOutlined style={{ color: 'red', marginRight: 5, fontSize: '12px', cursor: 'pointer' }} />
              </Popconfirm>
            </Tooltip>
          </>
        ),
      });


      return(

        <div>
          {!showCompactLayoutEditor ? (
        <div>

            <Row justify="space-between" align="middle" style={{ marginBottom: 10 }}>
                    <Col>
                        <Title level={4}>Compact Layouts</Title>
                    </Col>
                    <Col>
                        <Button
                            type="primary"
                            onClick={() => {
                                if(!security?.system_settings?.compact_layout?.create){
                                    message.error('You do not have permission to create compact layout');
                                    return;
                                }
                                setSelectedCompactLayout(null);
                                setShowCompactLayoutEditor(true);
                            }}
                        >
                            Create Compact Layout
                        </Button>
                    </Col>
                </Row>

                    {/* Render layouts in a table */}
                    <Table
                        dataSource={allcompactLayout ? [allcompactLayout] : []} 
                        columns={columns}
                        rowKey="_id"
                        scroll={{ y: 550 }}
                        pagination={{
                            pageSize: pageSize,
                            showSizeChanger: true,
                            pageSizeOptions: ['10', '20', '50', '100'],
                            onChange: (page, pageSize) => {
                                setPageSize(pageSize);
                            },              
                            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        }}
                    />


        </div>
          ) : (
            <CompactLayoutEditor
                object={object?.name}
                fields={fields}
                selectedLayout={selectedCompactLayout}
                fetchCompactLayout={fetchCompactLayout}
                onBack={() => setShowCompactLayoutEditor(false)}
            />
        )}

        </div>


      );



}

export default CompactLayout;